export enum DateRangeFilter {
  Started = 0,
  Ended = 1,
  Calculated = 2,
  SettlementMonth = 3,
  All = 4,
  AllButSettlementMonth = 5,
  Modified = 6,
}
